function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M252.786 45.1326H301.665V55.8875H284.637V85.0909H269.689V55.8875H252.786V45.1326Z",
  fill: "white"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M81.9194 77.1304L82.1433 81.0926L75.3174 79.338L75.9735 74.7145L80.597 75.3706L81.9194 77.1304Z",
  fill: "#C8A831"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M76.6235 70.0969L76.8474 74.0592L70.0215 72.3045L70.6776 67.681L75.3011 68.3371L76.6235 70.0969Z",
  fill: "#C8A831"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M71.3352 63.0557L71.559 67.0179L64.7332 65.2633L65.3893 60.6398L70.0127 61.2959L71.3352 63.0557Z",
  fill: "#C8A831"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M45.5437 39.7439C52.8331 34.2662 63.1834 35.7344 68.6613 43.0236C73.2232 49.0943 72.9663 57.2874 68.5429 63.0216L71.5426 67.0133L70.0073 72.2984L75.5102 72.2932L76.8326 74.0529L75.5154 77.7961L80.139 78.4529L82.1226 81.0925L81.2479 87.2566L72.0009 85.9451L59.2743 69.0094C53.0826 70.4747 46.3303 68.2725 42.2635 62.8607C36.786 55.5714 38.2548 45.2218 45.5437 39.7439ZM49.9465 47.4478C47.0312 49.639 46.4437 53.7783 48.6344 56.694C50.8255 59.6096 54.9654 60.1975 57.8812 58.0068C60.797 55.8157 61.3845 51.6751 59.1934 48.7593C57.0022 45.8438 52.8622 45.2568 49.9465 47.4478Z",
  fill: "url(#paint0_linear_15991_11300)"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M66.2592 65.4849C65.6595 65.9356 65.0384 66.3391 64.4016 66.6964C70.2142 60.9836 71.0413 51.7093 66.0113 45.0158C60.9851 38.3271 51.8573 36.5405 44.7552 40.523C45.272 40.0153 45.8272 39.5341 46.4222 39.087C53.7117 33.6095 64.0618 35.0787 69.5395 42.3681C75.017 49.6575 73.5484 60.0071 66.2592 65.4849Z",
  fill: "#C8A831"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M367.581 45.1326V85.0375L382.903 84.9426V71.1983H391.942L404.823 84.9306H421.001L407.861 70.9218C416.976 69.5084 420.379 63.315 420.379 58.0597C420.379 51.9033 418.012 45.1326 402.656 45.1327L367.581 45.1326ZM382.854 54.0546H402.321C402.321 54.0546 406.162 54.0546 406.162 57.8612C406.162 61.6679 402.321 61.9665 402.321 61.9665H382.854V54.0546Z",
  fill: "white"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M303.531 64.1444C303.531 55.7894 307.335 44.3279 332.515 44.3279H335.018C360.198 44.3279 364.003 55.7894 364.003 64.1444V65.7513C364.003 73.9456 360.148 85.7819 335.018 85.7819H332.515C307.436 85.7819 303.531 73.9456 303.531 65.7513V64.1444ZM319.337 64.6205C319.337 60.6332 321.153 55.1635 333.17 55.1635H334.364C346.381 55.1635 348.196 60.6332 348.196 64.6205V65.3872C348.196 69.2978 346.356 74.9464 334.364 74.9464H333.17C321.201 74.9464 319.337 69.2978 319.337 65.3872V64.6205Z",
  fill: "white"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M169.117 45.1326H213.349V54.7377H184.062V60.1362H212.625V69.2417H184.062V75.2747H213.349V85.0375H169.117V45.1326Z",
  fill: "white"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M148.983 45.1326H163.887V85.0375H148.983V45.1326Z",
  fill: "white"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M91.6653 45.3478L91.6654 84.18L106.69 84.0877V70.713H118.398L128.425 84.0761H142.847L132.442 70.2082C140.424 68.4788 143.442 62.7903 143.442 57.9274C143.442 51.9366 141.12 45.3478 126.062 45.3479L91.6653 45.3478ZM106.644 54.0299H125.146C125.146 54.0299 128.796 54.0299 128.796 57.7343C128.796 61.4386 125.146 61.7292 125.146 61.7292H106.644V54.0299Z",
  fill: "white"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M218.223 45.1326H233.293V73.6614H260.905V85.0909H218.223V45.1326Z",
  fill: "white"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M60.5904 88.4049L58.4434 91.6254L54.1494 86.2579L57.3699 83.0374L60.5904 86.2579V88.4049Z",
  fill: "#C8A831"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M60.5904 79.8151L58.4434 83.0356L54.1494 77.6681L57.3699 74.4476L60.5904 77.6681V79.8151Z",
  fill: "#C8A831"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M60.5904 71.2292L58.4434 74.4497L54.1494 69.0822L57.3699 65.8617L60.5904 69.0822V71.2292Z",
  fill: "#C8A831"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M54.1482 37.9432C63.0414 37.9432 70.2507 45.1525 70.2507 54.0457C70.2507 61.4546 65.2467 67.6935 58.4343 69.5701V74.4393L54.1404 77.66L58.4343 80.8807V83.0272L55.2146 85.1746L58.4343 88.3953V91.616L54.1404 95.91L47.7 89.4686V68.8035C42.017 66.3169 38.0457 60.6457 38.0457 54.0457C38.0457 45.1525 45.255 37.9432 54.1482 37.9432ZM53.0769 46.533C49.5196 46.533 46.6355 49.4171 46.6355 52.9744C46.6358 56.5315 49.5198 59.4148 53.0769 59.4148C56.6338 59.4146 59.5171 56.5313 59.5173 52.9744C59.5173 49.4173 56.634 46.5333 53.0769 46.533Z",
  fill: "url(#paint1_linear_15991_11300)"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M53.0886 46.5418C53.8407 46.5418 54.5622 46.672 55.2332 46.909C52.7312 47.7931 50.9382 50.1786 50.9382 52.9832C50.9384 55.7875 52.7315 58.1713 55.2332 59.0555C54.5621 59.2925 53.8408 59.4236 53.0886 59.4236C49.5315 59.4236 46.6474 56.5403 46.6472 52.9832C46.6472 49.4259 49.5313 46.5418 53.0886 46.5418Z",
  fill: "#C8A831"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M55.2227 70.1647C54.4952 70.1647 53.779 70.1166 53.0771 70.0231C60.956 68.9741 67.0342 62.2279 67.0342 54.0622C67.0342 45.8965 60.9559 39.1513 53.0772 38.1022C53.7791 38.0088 54.4952 37.9597 55.2227 37.9597C64.1158 37.9597 71.3252 45.169 71.3252 54.0622C71.3252 62.9554 64.1158 70.1647 55.2227 70.1647Z",
  fill: "#C8A831"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M324.789 106.184V112.728C324.789 113 324.949 113.144 325.205 113.144H325.845V116.744H324.437V114.92C324.437 114.648 324.277 114.504 324.021 114.504H318.277C318.021 114.504 317.861 114.648 317.861 114.92V116.744H316.437V113.144H316.965C317.189 113.144 317.349 113.08 317.461 112.888C317.829 112.152 317.989 110.616 317.989 107.8V106.184H324.789ZM318.949 112.712C318.869 113 318.981 113.176 319.285 113.176H322.933C323.205 113.176 323.349 113.032 323.349 112.76V107.912C323.349 107.64 323.189 107.496 322.933 107.496H319.829C319.557 107.496 319.397 107.656 319.397 107.928V107.976C319.381 110.152 319.253 111.656 318.949 112.712Z",
  fill: "white"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M312.474 106.184H313.914V114.504H312.474V106.184ZM312.378 103H314.01V104.616H312.378V103Z",
  fill: "white"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M302 114.504V106.184H306C307.968 106.184 309.104 106.968 309.104 108.44C309.104 109.16 308.832 109.704 308.304 110.072C308.128 110.2 308.144 110.296 308.32 110.392C308.96 110.744 309.296 111.32 309.296 112.12C309.296 113.64 308.128 114.504 306.128 114.504H302ZM303.424 112.952C303.424 113.144 303.536 113.24 303.712 113.24H306.16C307.312 113.24 307.744 112.936 307.744 112.168V111.96C307.744 111.192 307.312 110.904 306.16 110.904H303.712C303.536 110.904 303.424 111 303.424 111.192V112.952ZM303.424 109.432C303.424 109.624 303.536 109.72 303.712 109.72H306.016C307.136 109.72 307.568 109.432 307.568 108.68V108.472C307.568 107.736 307.136 107.448 306.016 107.448H303.712C303.536 107.448 303.424 107.544 303.424 107.736V109.432Z",
  fill: "white"
});

var _ref23 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_15991_11300)"
}, React.createElement("path", {
  d: "M376.321 101.875H388.398V116.732H385.214V105.611C385.214 105.144 384.96 104.889 384.493 104.889H380.142C379.696 104.889 379.441 105.144 379.441 105.611V105.823C379.378 114.164 378.486 116.732 374.942 116.732H373.371V113.718H374.454C375.6 113.718 376.321 112.997 376.321 104.974V101.875Z",
  fill: "white"
}), React.createElement("path", {
  d: "M393.374 116.732V113.718H396.303C396.876 113.718 397.088 113.358 396.791 112.848L390.296 101.875H393.947L398.383 109.643C398.68 110.174 399.126 110.131 399.359 109.558L402.394 101.875H405.769L400.675 113.909C399.869 115.862 398.553 116.732 396.452 116.732H393.374Z",
  fill: "white"
}), React.createElement("path", {
  d: "M407.637 101.875H410.821V106.969C410.821 107.436 411.076 107.691 411.543 107.691H417.04C417.507 107.691 417.761 107.436 417.761 106.969V101.875H420.945V116.732H417.761V111.426C417.761 110.959 417.507 110.704 417.04 110.704H411.543C411.076 110.704 410.821 110.959 410.821 111.426V116.732H407.637V101.875Z",
  fill: "white"
}), React.createElement("path", {
  d: "M348.966 109.176V126.359C348.854 126.359 348.748 126.332 348.647 126.274L334.32 118.005C334.123 117.893 334 117.68 334 117.45V100.907C334 100.795 334.032 100.683 334.085 100.587L348.966 109.176Z",
  fill: "#F3430D"
}), React.createElement("path", {
  d: "M363.847 100.587L348.966 109.176L334.085 100.587C334.138 100.491 334.218 100.412 334.32 100.353L348.647 92.0839C348.844 91.972 349.089 91.972 349.286 92.0839L363.613 100.353C363.714 100.412 363.789 100.491 363.847 100.587Z",
  fill: "#FF5700"
}), React.createElement("path", {
  d: "M363.933 100.907V117.45C363.933 117.68 363.81 117.887 363.613 118.005L349.286 126.274C349.19 126.332 349.078 126.359 348.966 126.359V109.176L363.847 100.587C363.906 100.683 363.933 100.795 363.933 100.907Z",
  fill: "#FD7E3C"
}));

var _ref24 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear_15991_11300",
  x1: 45.5441,
  y1: 39.7437,
  x2: 81.2482,
  y2: 87.2563,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#F7D341"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#E9C628"
})), React.createElement("linearGradient", {
  id: "paint1_linear_15991_11300",
  x1: 54.1482,
  y1: 37.9432,
  x2: 54.1482,
  y2: 95.9098,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#F7D341"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#E9C628"
})), React.createElement("clipPath", {
  id: "clip0_15991_11300"
}, React.createElement("rect", {
  width: 87,
  height: 34.3605,
  fill: "white",
  transform: "translate(334 92)"
})));

var SvgLogoBig = function SvgLogoBig(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 425,
    height: 127,
    viewBox: "0 0 425 127",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoBig, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-big.bd023c09.svg";
export { ForwardRef as ReactComponent };